/**
 * @description  Widget labels entry
 */

export default Object.freeze({
  ON_EACH_INTERACTION: 'ON_EACH_INTERACTION',
  ON_BOT_INTERACTION: 'ON_BOT_INTERACTION',
  ON_LIVECHAT_INTERACTION: 'ON_LIVECHAT_INTERACTION',
  ON_LAST_INTERACTION: 'ON_LAST_INTERACTION',
})
